export enum NotificationEvent {
  EXPEDITION_READY = 'EXPEDITION_READY',
  VEHICLE_ARRIVING = 'VEHICLE_ARRIVING',
  PICKUP_UPDATED = 'PICKUP_UPDATED',
  SERVICE_ALTERATION = 'SERVICE_ALTERATION',
  TRIP_FEEDBACK = 'TRIP_FEEDBACK',
  DRIVER_EXPEDITION_CREATED = 'DRIVER_EXPEDITION_CREATED',
  DRIVER_EXPEDITION_CHANGED = 'DRIVER_EXPEDITION_CHANGED',
  DRIVER_EXPEDITION_DELETED = 'DRIVER_EXPEDITION_DELETED',
  DRIVER_REASSIGNED = 'DRIVER_REASSIGNED',
  DRIVER_ROADMAP_READY = 'DRIVER_ROADMAP_READY',
  EXPEDITION_DELAYED = 'EXPEDITION_DELAYED',
  EXPEDITION_NOT_STARTED = 'EXPEDITION_NOT_STARTED',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  RESERVATION_CHANGED = 'RESERVATION_CHANGED',
  RESERVATION_CANCELLED = 'RESERVATION_CANCELLED',
  RESERVATION_MISSED = 'RESERVATION_MISSED',
  SCHEDULED_RESERVATION_REMINDER = 'SCHEDULED_RESERVATION_REMINDER',
  SCHEDULED_RESERVATION_FAILED = 'SCHEDULED_RESERVATION_FAILED',
  SCHEDULER_ENDING = 'SCHEDULER_ENDING',
  DRIVER_RESERVATION_CREATED = 'DRIVER_RESERVATION_CREATED',
  DRIVER_RESERVATION_CHANGED = 'DRIVER_RESERVATION_CHANGED',
  DRIVER_RESERVATION_CANCELLED = 'DRIVER_RESERVATION_CANCELLED',
  PASS_PURCHASED = 'PASS_PURCHASED',
  PASS_EXPIRED = 'PASS_EXPIRED',
  REFUND_FAILED = 'REFUND_FAILED',
  PURCHASE_FAILED = 'PURCHASE_FAILED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  ACCOUNT_STATUS_CHANGED = 'ACCOUNT_STATUS_CHANGED',
  PENALTY = 'PENALTY',
  USER_DELETION_REQUESTED = 'USER_DELETION_REQUESTED',
  PASSENGER_SUGGESTION_CREATED = 'PASSENGER_SUGGESTION_CREATED',
  DRIVER_SUGGESTION_CREATED = 'DRIVER_SUGGESTION_CREATED',
  PASSENGER_SUGGESTION_COMMENTED = 'PASSENGER_SUGGESTION_COMMENTED',
  DRIVER_SUGGESTION_COMMENTED = 'DRIVER_SUGGESTION_COMMENTED',
  SUGGESTION_ANSWERED = 'SUGGESTION_ANSWERED',
}
